import { Button, Divider, Typography } from "@mui/material";
import styled from "styled-components";

export const HeaderButton = styled(Button)`
    && {
        color: ${({ theme }) => theme.palette.primary.contrastText};
    }
`;

export const Logo = styled.svg`
    display: block;
    height: 40px;
    margin-top: -5px;
`;

export const StyledDivider = styled(Divider)`
    && {
        height: 30px;
    }
`;

export const UserName = styled(Typography)`
    && {
        font-weight: 400;
    }
`;
